<template>
  <div class="card" v-wechat-title="$route.meta.title">
    <div class="bottom1">
      <hr
        :style="'width:' + ((mark + 1) / questionList.length) * 100 + '%'"
        class="progress"
      />
      <hr
        :style="'width:' + (1 - (mark + 1) / questionList.length) * 100 + '%'"
        class="bg"
      />
      <p>
        <span style="color: #42686e" class="f20">{{ mark + 1 }}</span
        >/{{ questionList.length
        }}<span class="fr mr-10 f14 gray timeover">{{ testTime }}</span>
      </p>
    </div>
    <div class="container">
      <div class="swiper">
        <div
          class="swiper-container"
          ref="items"
          :style="`transform: translateX(${-move}vw)`"
        >
          <div
            ref="item"
            class="swiper-item"
            v-for="(item, quesNum) in questionList"
            :key="quesNum"
            :class="{ active: quesNum == 0 }"
          >
            <div class="center" ref="centerDiv">
              <div
                class="center_content"
                ref="center"
                :class="{ show: quesNum == 0 }"
              >
                <p class="ques f16">
                  <span class="quesorder">{{ mark + 1 }}. </span
                  ><span class="content_ques">{{ item.description }}</span>
                </p>
                <div class="center_container">
                  <div
                    v-show="item.option_list.length < 10"
                    v-for="(option, i) in item.option_list"
                    :key="+option.number"
                    class="item"
                    @click="
                      updateAnswer(
                        $event,
                        mark,
                        i,
                        +option.number,
                        item.choices
                      )
                    "
                    ref="btn"
                  >
                    <div class="btn" :ref="'ques' + quesNum">
                      <div class="spanBox">
                        <span class="left_span">{{ indexArr[i] }}.</span
                        ><span class="right_span">{{
                          option.description
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-show="item.option_list.length > 9">
                    <div
                      style="
                        font-size: 13px;
                        margin: 50px 0 30px 0;
                        text-align: left;
                        display: flex;
                      "
                    >
                      <div
                        @click="onChange(0, mark)"
                        :class="
                          selectedListModel[mark] == 0 ? 'normalV' : 'activeV'
                        "
                      >
                        0%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(20, mark)"
                        :class="
                          selectedListModel[mark] == 20 ? 'normalV' : 'activeV'
                        "
                      >
                        20%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(40, mark)"
                        :class="
                          selectedListModel[mark] == 40 ? 'normalV' : 'activeV'
                        "
                      >
                        40%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(60, mark)"
                        :class="
                          selectedListModel[mark] == 60 ? 'normalV' : 'activeV'
                        "
                      >
                        60%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(80, mark)"
                        :class="
                          selectedListModel[mark] == 80 ? 'normalV' : 'activeV'
                        "
                      >
                        80%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(100, mark)"
                        :class="
                          selectedListModel[mark] == 100 ? 'normalV' : 'activeV'
                        "
                      >
                        100%
                      </div>
                    </div>

                    <van-slider
                      active-color="#42686E"
                      inactive-color="rgb(214,214,214)"
                      style="height: 10px; width: 90%; margin-left: 5px"
                      v-model="selectedListModel[mark]"
                      @change="onChange($event, mark)"
                      step="10"
                    />
                    <div
                      style="
                        font-size: 13px;
                        display: flex;
                        margin: 30px 0 50px 0;
                        text-align: left;
                      "
                    >
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(10, mark)"
                        :class="
                          selectedListModel[mark] == 10 ? 'normalV' : 'activeV'
                        "
                      >
                        10%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(30, mark)"
                        :class="
                          selectedListModel[mark] == 30 ? 'normalV' : 'activeV'
                        "
                      >
                        30%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(50, mark)"
                        :class="
                          selectedListModel[mark] == 50 ? 'normalV' : 'activeV'
                        "
                      >
                        50%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(70, mark)"
                        :class="
                          selectedListModel[mark] == 70 ? 'normalV' : 'activeV'
                        "
                      >
                        70%
                      </div>
                      <div style="flex: 1"></div>
                      <div
                        @click="onChange(90, mark)"
                        :class="
                          selectedListModel[mark] == 90 ? 'normalV' : 'activeV'
                        "
                      >
                        90%
                      </div>
                      <div style="flex: 1"></div>
                    </div>
                    <div
                      @click="submitPart(quesNum)"
                      :ref="'button' + quesNum"
                      class="btn"
                      style="
                        padding: 0;
                        line-height: 1.2rem;
                        width: 60%;
                        margin: 0 auto;
                      "
                    >
                      <div class="spanBox">
                        <span class="right_span" style="margin: 0 auto"
                          >确定</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- v-lazy="testImg"  -->
              <div ref="centerImg" class="center_img"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom mb-20">
      <p @click="exit()" class="pl-10 card_quit" style="padding: 2px">
        <img
          style="height: 24px; width: 24px"
          src="../../../assets/img/quit_btn.png"
          alt=""
        /><br /><span style="font-size: 10px">退出</span>
      </p>
      <van-button @click="prevI()" ref="BackArrow" class="smbtn">
        上一题
      </van-button>
      <div class="card_exit" v-if="ShowExit">
        <div class="card_exit_box">
          <p class="card_exit_title">是否确认退出</p>
          <p class="card_exit_describle">退出后本次答题进度不保存</p>
          <div class="card_exit_btn">
            <button class="card_exit_btn_confirm" @click="toBack()">
              确认
            </button>
            <button class="card_exit_btn_fail" @click="exit(0)">取消</button>
          </div>
        </div>
      </div>
      <van-button
        @click="submit()"
        v-if="mark === questionList.length - 1"
        class="smbtn"
      >
        确认提交
      </van-button>
      <!-- <div class="ChiceBtn f16">
            <div class="ChiceBox">
                <span class="leftArrow" @click="prevI()" ref="BackArrow">
                    上一题 </span>
                <span class="rightArrow" @click="nextI()" ref="ForArrow">下一题
                </span>
            </div>
        </div> -->
    </div>
  </div>
</template>

<script>
import test_detail from "./test_detail";
import { mapGetters } from "vuex";
import { store } from "./../../../store/index";
import {
  getTestDetail,
  submitComment,
  submitPartComment,
  getNextQuestion,
} from "@/http/api";
import { shouldUseWecomReportGate } from "@/config/reportGate";
import { Message, Loading } from "element-ui";
import Vue from "vue";
import { Swipe, SwipeItem, Toast, Slider } from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Slider);
export default {
  name: "detail",
  components: {
    test_detail,
  },
  data() {
    return {
      // moveDis:ewh,
      value: 0,
      move: 0,
      color: [
        "#000",
        "#4269eb",
        "#247302",
        "pink",
        "orange",
        "yellow",
        "hotpink",
        "rgb(222,0,0)",
      ],
      index: 0,
      isActive: true,
      testTime: "00:00",
      selectedIndex: -1,
      ms: 0,
      s: 0,
      m: 0,
      h: 0,
      mark: 0,
      testImg: require("./../../../assets/img/test/testBg.png"),

      indexArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      questionList: [],
      answerList: [],
      selectedList: [],
      selectedListModel: [],
      item: {},
      // 定时器
      animateTimeout: 0,
      nextTimeout: 0,
      ShowExit: false,
      question_flag: 0,
      arr1: [],
      arr2: [],
      arr3: [],
      resultData: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log();
    var end = from.path.slice(from.path.lastIndexOf("/"));
    console.log(end);
    if (end !== "/note") {
      next(from.path.slice(0, from.path.lastIndexOf("/")));
    }
    localStorage["result"] = 0;
    next();
  },
  methods: {
    onChange(value, ques_i) {
      //  this.selectedList[ques_i] = value/10;
      this.$set(this.selectedList, ques_i, value / 10);
      this.$set(this.selectedListModel, ques_i, value);
      this.answerList[ques_i] =
        this.questionList[ques_i].option_list[value / 10].number;
      //  this.nextI();
    },
    prevI() {
      if (this.move != 0) {
        if (this.index != 0) {
          this.$refs.centerImg[this.index - 1].classList.remove("show");
        }
        // this.$refs.centerImg[this.index+1].classList.remove("bw")
        // this.$refs.centerImg[this.index+1].classList.remove("show")
        this.$refs.center[this.index].classList.remove("show");
        this.$refs.item[this.index].classList.remove("active");
        this.move -= 90;
        this.index -= 1;
        this.mark--;
        if (this.index != 0) {
          this.$refs.centerImg[this.index - 1].classList.add("show");
        }
        this.$refs.center[this.index].classList.add("show");
        this.$refs.item[this.index].classList.add("active");
      }
      // console.log(this.$refs.item.classList.add("active"))
    },
    nextI(quesNum) {
      if (quesNum) {
        this.$refs["button" + quesNum][0].classList.add("btnSelected");
      }
      setTimeout(() => {
        if (this.answerList[this.index] !== undefined) {
          console.log(this.index);
          if (this.question_flag > 0 && this.question_flag == this.index + 1) {
            this.nextQuestion();
          }

          if (this.index < this.questionList.length - 1) {
            if (this.index > 1) {
              this.$refs.centerImg[this.index - 1].classList.remove("show");
            }
            // this.$refs.centerImg[this.index+1].classList.remove("bw")
            // this.$refs.centerImg[this.index+1].classList.remove("show")
            this.$refs.center[this.index].classList.remove("show");
            this.$refs.item[this.index].classList.remove("active");
            this.move += 90;
            this.index += 1;
            this.mark++;
            console.log(this.move);
            console.log(this.index);
            console.log(this.mark);
            // this.$refs.centerImg[this.index+1].classList.add("bw")
            // this.$refs.centerImg[this.index+1].classList.add("show")
            this.$refs.centerImg[this.index - 1].classList.add("show");
            this.$refs.center[this.index].classList.add("show");
            this.$refs.item[this.index].classList.add("active");
          }
        } else {
          // Message({
          //   message: "请选择答案",
          //   type: "error",
          // });
        }
      }, 200);
    },
    godAction() {
      console.log(this.questionList.length);
      var a = [];
      for (var i = 0; i < this.questionList.length; i++) {
        a.push(0);
      }
      this.answerList = a;
      this.mark = 0;
      this.submit();
      // this.selectedList=
    },
    exit(params) {
      if (params === 0) {
        this.ShowExit = false;
      } else {
        this.ShowExit = true;
      }
    },
    toBack() {
      var savedData = {
        answerList: this.answerList,
        selectedList: this.selectedList,
        selectedIndex: -1,
        indexArr: this.indexArr,
        mark: this.mark,
      };
      // sessionStorage.setItem(location.hash.split('/')[2], JSON.stringify(savedData))
      this.$router.push("./../../index");
    },
    pre(index) {
      // //console.log('start:', Date.now())
      // //console.log(this.$refs)
      if (index !== 0) {
        // 更新题目
        //console.log('这里回退',this.mark)
        this.mark--;
        this.item = this.questionList[this.mark];
        // 添加动效
        this.$refs.leftDiv.classList.add("animated", "slideInLeft");
        this.$refs.centerDiv.classList.add("animated", "slideInLeft");
        if (index !== this.questionList.length - 1) {
          this.$refs.rightDiv.classList.add("animated", "slideInLeft");
        }
        // 修改样式
        let option_i = this.selectedList[this.mark];
        this.$refs.btn.forEach((u, i) => {
          // //console.log(u, i, option_i)
          if (i === option_i) {
            this.$refs.btn[i].firstElementChild.classList.remove("btn");
            this.$refs.btn[i].firstElementChild.classList.add("btnSelected");
          } else {
            // this.$refs.btn[i].firstElementChild.classList.remove('btnSelected')
            this.$refs.btn[i].firstElementChild.classList.add("btn");
          }
        });
      }
      this.throttle(
        setTimeout(() => {
          // 移除动效
          this.$refs.leftDiv.classList.remove("animated", "slideInLeft");
          this.$refs.centerDiv.classList.remove("animated", "slideInLeft");
          if (index !== this.questionList.length - 1) {
            this.$refs.rightDiv.classList.remove("animated", "slideInLeft");
          }
        }, 1000),
        100000
      );
    },
    next(index) {
      if (this.answerList[index] !== undefined) {
        if (index !== this.questionList.length - 1) {
          // 更新题目
          this.mark++;
          this.item = this.questionList[this.mark];
          let option_i = this.selectedList[this.mark];
          this.$refs.btn.forEach((u, i) => {
            // //console.log(u, i, option_i)
            if (i === option_i) {
              this.$refs.btn[i].firstElementChild.classList.remove("btn");
              this.$refs.btn[i].firstElementChild.classList.add("btnSelected");
            } else {
              // this.$refs.btn[i].firstElementChild.classList.remove('btnSelected')
              this.$refs.btn[i].firstElementChild.classList.add("btn");
            }
          });
        }
        this.nextI();
      } else {
        Message({
          message: "请选择答案",
          type: "error",
        });
      }
    },
    timer() {
      //定义计时函数
      this.ms = this.ms + 50; //毫秒
      if (this.ms >= 1000) {
        this.ms = 0;
        this.s = this.s + 1; //秒
      }
      if (this.s >= 60) {
        this.s = 0;
        this.m = this.m + 1; //分钟
      }
      this.testTime = this.toDub(this.m) + ":" + this.toDub(this.s);
    },
    reset() {
      clearInterval(this.time);
      this.h = 0;
      this.m = 0;
      this.ms = 0;
      this.s = 0;
      this.testTime = "00:00";
    },
    start() {
      this.time = setInterval(this.timer, 50);
    },
    stop() {
      clearInterval(this.time);
    },
    toDub(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    },
    // 收集答案

    updateAnswer(e, ques_i, option_i, option_score, choices) {
      if (choices == 1) {
        for (let i = 0; i < this.$refs["ques" + ques_i].length; i++) {
          this.$refs["ques" + ques_i][i].classList.remove("btnSelected");
        }

        this.$refs["ques" + ques_i][option_i].classList.add("btnSelected");
        this.selectedList[ques_i] = option_i;
        this.answerList[ques_i] = option_score;
        console.log(this.selectedList);
        this.submitPart();
        // this.nextI();
      } else if (choices > 1) {
        if (
          this.$refs["ques" + ques_i][option_i].className == "btn btnSelected"
        ) {
          this.$refs["ques" + ques_i][option_i].classList.remove("btnSelected");
          for (let i = 0; i < this.resultData[ques_i].length; i++) {
            if (this.resultData[ques_i][i] == option_score) {
              // this.selectedList[ques_i].splice(i, 1);
              // this.answerList[ques_i].splice(i, 1);
              this.resultData[ques_i].splice(i, 1);
            }
          }
        } else {
          this.$refs["ques" + ques_i][option_i].classList.add("btnSelected");
          if (this.resultData[ques_i] == undefined) {
            console.log("啊啊啊啊啊啊啊啊鸭鸭");
            // this.arrs.push(option_score);
            // this.resultData[ques_i] = this.arrs;
            this.arr2.push(option_i);
            this.arr3.push(option_score);
            this.selectedList[ques_i] = this.arr2;
            this.answerList[ques_i] = this.arr3;
            this.resultData[ques_i] = this.answerList[ques_i];
          } else {
            this.arr1 = this.resultData[ques_i];
            this.arr1.push(option_score);
            this.resultData[ques_i] = this.arr1;
          }
        }
        var checkNum = 0;
        for (let j = 0; j < this.$refs["ques" + ques_i].length; j++) {
          if (this.$refs["ques" + ques_i][j].className == "btn btnSelected") {
            checkNum += 1;
          }
          if (checkNum > choices) {
            Toast("你只能选择" + choices + "个选项");
          }
        }
        if (checkNum == choices) {
          this.submitPart();
          this.arr1 = [];
          this.arr2 = [];
          this.arr3 = [];
        }
      }
    },
    nextQuestion() {
      let params = {
        appraisal_id: this.appraisal_id,
        items: {},
      };
      this.questionList.forEach((u, i) => {
        params.items[u.number] = this.answerList[i];
      });
      getNextQuestion(params).then((res) => {
        //console.log(res)
        if (res.code === "SUCCESS") {
          if (res.data.length > 0) {
            console.log(res);
            this.questionList = [
              ...this.questionList.slice(0, this.question_flag),
              ...res.data,
            ];
            console.log(this.questionList);
            let i = 0;
            for (i; i < this.questionList.length; i++) {
              this.$set(this.selectedListModel, i, null);
            }
          } else {
            this.submit();
          }
        } else {
          Message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    submitPart(quesNum) {
      let params = {
        appraisal_id: this.appraisal_id,
        items: {},
      };
      // this.answerList.forEach((u, i) => {
      //     params.items[i + 1] = u;
      // })
      this.questionList.forEach((u, i) => {
        params.items[u.number] = this.answerList[i];
      });
      //console.log(params)
      submitPartComment(params).then((res) => {
        if (res.code === "SUCCESS") {
          this.nextI(quesNum);
        }
      });
    },
    // 提交测评结果
    submit() {
      if (this.answerList[this.mark] !== undefined) {
        this.stop();
        let params = {
          appraisal_id: this.appraisal_id,
          items: {},
        };
        // this.answerList.forEach((u, i) => {
        //     params.items[i + 1] = u;
        // })
        this.questionList.forEach((u, i) => {
          params.items[u.number] = this.answerList[i];
        });
        submitComment(params).then((res) => {
          if (res.code === "SUCCESS") {
            if (shouldUseWecomReportGate(this.eval_id)) {
              this.$router.push("./wecomGate");
            } else {
              this.$router.push("./result");
            }
          } else {
            Message({
              message: res.msg,
              type: "error",
            });
          }
        });
      } else {
        Message({
          message: "请选择答案",
          type: "error",
        });
      }
    },
    shuffle(array) {
      let len = array.length;
      for (let i = len - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    throttle(func, wait) {
      let previous = 0;
      return function () {
        let now = Date.now();
        let context = this;
        let args = arguments;
        if (now - previous > wait) {
          func.apply(context, args);
          previous = now;
        }
      };
    },
  },
  computed: {
    ...mapGetters(["user", "user_id", "eval_id", "appraisal_id"]),
  },
  created: function () {
    getTestDetail(this.eval_id).then((res) => {
      console.log(res, "asdasdsddas");
      this.$route.meta.title = res.data.title;
      // this.questionList = this.shuffle(res.data.question_list)
      this.questionList = res.data.question_list;
      this.question_flag = res.data.question_flag || 0;
      this.testImg = res.data.detail_image;
      this.item = this.questionList[this.mark];
      let result_json = res.data.exist_appraisal.result_json;

      this.arr = this.answerList;
      this.arrs = this.selectedList;

      let existData = Object.values(result_json) || [];
      this.resultData = Object.values(result_json) || [];
      let i = 0;
      for (i; i < this.questionList.length; i++) {
        if (this.questionList[i].option_list.length > 8) {
          this.$set(this.selectedListModel, i, 0);
          this.$set(this.selectedList, i, 0);
          this.$set(this.answerList, i, 1);
        } else {
          this.$set(this.selectedListModel, i, null);
        }
      }
      if (
        existData.length &&
        existData.length != this.selectedListModel.length
      ) {
        this.move = existData.length * 90;
        this.index = existData.length;
        this.mark = existData.length;
        console.log(this.move);
        this.selectedListModel.forEach((item, index) => {
          if (existData.length > index) {
            item = existData[index];
            this.selectedList[index] = existData[index];
            this.answerList[index] = existData[index];
          }
        });
        console.log("this.selectedList");
        console.log(result_json);
        console.log(this.selectedList);
        setTimeout(() => {
          this.$refs.centerImg[this.index - 1].classList.add("show");
          this.$refs.center[this.index].classList.add("show");
          this.$refs.item[this.index].classList.add("active");
          for (let i = 0; i < existData.length; i++) {
            this.$nextTick(function () {
              if (Array.isArray(existData[i])) {
                for (let k = 0; k < existData[i].length; k++) {
                  this.$refs["ques" + i][existData[i][k] - 1].classList.add(
                    "btnSelected"
                  );
                }
              } else {
                this.$refs["ques" + i][existData[i] - 1].classList.add(
                  "btnSelected"
                );
              }
              // this.$refs["ques" + i][existData[i] - 1].classList.add(
              //   "btnSelected"
              // );
            });
          }
        }, 200);
      } else if (existData.length == this.selectedListModel.length) {
        this.move = (existData.length - 1) * 90;
        this.index = existData.length - 1;
        this.mark = existData.length - 1;
        console.log(this.move);
        this.selectedListModel.forEach((item, index) => {
          if (existData.length > index) {
            item = existData[index];
            this.selectedList[index] = existData[index];
            this.answerList[index] = existData[index];
          }
        });
        setTimeout(() => {
          this.$refs.centerImg[this.index - 1].classList.add("show");
          this.$refs.center[this.index].classList.add("show");
          this.$refs.item[this.index].classList.add("active");
          for (let i = 0; i < existData.length; i++) {
            this.$nextTick(function () {
              if (Array.isArray(existData[i])) {
                for (let k = 0; k < existData[i].length; k++) {
                  this.$refs["ques" + i][existData[i][k] - 1].classList.add(
                    "btnSelected"
                  );
                }
              } else {
                this.$refs["ques" + i][existData[i] - 1].classList.add(
                  "btnSelected"
                );
              }
              // this.$refs["ques" + i][existData[i] - 1].classList.add(
              //   "btnSelected"
              // );
            });
          }
        }, 200);
      }
    });
  },
  mounted: function () {
    this.start();
  },
  updated: function () {
    if (this.selectedIndex == -1) {
      let option_i = this.selectedList[this.mark];
      if (this.$refs.btn !== undefined) {
        this.$refs.btn.forEach((u, i) => {
          // console.log(u, i, option_i)
          if (i === option_i) {
            // this.$refs.btn[i].firstElementChild.classList.remove('btn')
            // this.$refs.btn[i].firstElementChild.classList.add('btnSelected')
          } else {
            // this.$refs.btn[i].firstElementChild.classList.remove('btnSelected')
            // this.$refs.btn[i].firstElementChild.classList.add('btn')
          }
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.card {
}
.van-slider__bar {
}

.timeover {
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 23px;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.normalV {
  cursor: pointer;
  color: #42686e;
  font-weight: 600;
  background: #42686e;
  color: white;
  border-radius: 4px;
  padding: 2px;
}

.activeV {
  cursor: pointer;
  border-radius: 4px;
  padding: 2px;
}

.card {
  /*margin-top: 40px;*/
  background-image: url("./../../../assets/img/testback.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: 40px;
  background-position-y: 71px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // height: 100%;

  .card_exit {
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 30;

    .card_exit_box {
      display: flex;
      flex-direction: column;
      /*justify-content: space-evenly;*/
      .w(337);
      height: 207px;
      background: #fff;
      border-radius: 12px;
      padding-top: 50px;
      /*position: absolute;*/
      /*left:0;top:0;right:0;bottom:0;*/
      /*margin:auto;*/

      p {
        text-align: center;
      }

      .card_exit_title {
        font-size: 22px;
        /*margin-top:38px;*/
      }

      .card_exit_describle {
        font-size: 12px;
        color: #9b9b9b;
        line-height: 22px;
      }

      .card_exit_btn {
        padding-top: 10px;
        .w(302);
        margin: 23px auto 0;
        border-top: 1px solid #eaeaea;
        text-align: center;
        /*padding-top:22px;*/

        button {
          .w(113);
          height: 45px;
          border-radius: 18px;
          font-size: 18px;
          text-align: center;
          line-height: 45px;
          border: none;
        }

        .card_exit_btn_confirm {
          background-color: #eceff5;
          color: #d0021b;
          margin-right: 18px;
          font-size: 18px;
          font-weight: 500;
        }

        .card_exit_btn_fail {
          color: #fff;
          background-color: #42686e;
        }
      }
    }
  }

  .container {
    .magictime {
      -webkit-animation-duration: 1s;
      -moz-animation-duration: 1s;
      -o-animation-duration: 1s;
      animation-duration: 1s;
    }
  }

  .smbtn {
    // position: absolute;
    // margin-top: 40%;
    width: 90%;
    margin-left: 5%;
    border-radius: 18px;
    background-color: #42686e;
    color: white;
    font-size: 20px;
    // margin-bottom: 20px;
    justify-content: center !important;
  }

  .van-button {
    justify-content: flex-start;
    padding: 0 0.6rem;
  }

  .spanBox {
    display: flex;
    width: 100%;

    .right_span {
      display: block;
    }
  }

  .ChiceBtn {
    width: 100%;
    // height: 0.97rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .ChiceBox {
      width: 100%;
      // height: 0.97rem;
      // color: #cacaca;
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 16px;
        // font-weight: 400;
      }
    }
  }
}

.ques {
  /*margin-bottom: 0.5rem;*/
  line-height: 19px;
  font-weight: bolder;
  display: flex;

  > span {
    display: block;
  }

  .quesorder {
    width: 0.7rem;
  }

  .content_ques {
    flex: 1;
  }
}

.center_container {
  // height: 8rem;
  position: relative;
  top: 3vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-direction: column;
  z-index: 100;
  .item {
    width: 100%;
    margin-bottom: 0.32rem;

    span {
      line-height: 16px;
      text-align: start;
      // color: #4a4a4a;
    }
  }
}

.noShow {
  display: none;
}

.van-button::before {
  background-color: transparent;
  z-index: 10;
}

.bottom {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  display: flex;
  hr {
    display: inline-block;
  }

  .progress {
    background-color: #42686e;
    height: 5px;
  }

  .bg {
    background-color: #eceff5;
    height: 5px;
  }
}
.bottom1 {
  margin-left: auto;
  margin-right: auto;
  width: 90%;

  hr {
    display: inline-block;
  }

  .progress {
    background-color: #42686e;
    height: 5px;
  }

  .bg {
    background-color: #eceff5;
    height: 5px;
  }
}

[v-cloak] {
  display: none !important;
}
</style><style scoped>
.container {
  /* padding-top: 20px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* overflow: hidden; */
  overflow-y: auto;
  overflow-x: hidden;
  /*border-radius: 20px;*/
  /*min-height: 80%;*/
  height: 80%;
  width: 100%;
  position: relative;
}

.left {
  border-radius: 0 15px 15px 0;
  opacity: 0.8;
  width: 8%;
  height: 90%;
  position: relative;
  overflow: hidden;
}

.right {
  border-radius: 15px 0 0 15px;
  background-color: black;
  width: 8%;
  height: 90%;
  overflow: hidden;
  position: relative;
}

img {
  z-index: -1;
  /*border-radius: 15px;*/
}

.center {
  /*background-color: pink;*/
  display: flex;
  /* padding-top: 3vh; */
  padding-bottom: 10px;
  /*align-items: center;*/
  /* padding-left: 10px; */
  position: relative;
  width: 100%;
  min-height: 55vh;
  height: fit-content;
  /*overflow: hidden;*/
  border-radius: 15px;
  /*border: 2px solid pink;*/
}

.center_content {
  /*display: none;*/
  opacity: 0;
  transition: opacity 1s;
  /*border: 2px pink solid;*/
  width: 100%;
  height: fit-content;
  /*height: 100%;*/
  /*background-color: white;*/
  color: black;
  /*width: 40%;*/
  /*top:5vh;*/
  /*display: flex;*/
  padding-bottom: 10px;
  border-radius: 15px;
  flex-direction: column;

  position: relative;
}

/*.center:active{*/
/*opacity : 1*/
/*}*/
.center_img {
  border-radius: 15px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*height: 110%;*/
  opacity: 0.15;
  transition: opacity 0.5s;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.card {
  padding-top: 10px;
  /*padding-bottom: 10%;*/
}

.img_right {
  height: 100%;
  position: absolute;
  left: 0;
  /*opacity: 0.15;*/
}

.img_left {
  height: 100%;
  position: relative;
  /*right: 100%;*/
  /*opacity: 0.15;*/
}

.btn {
  padding: 10px;
  min-height: 45px;
  width: 95%;
  border-radius: 9px;
  /*background-color: black;*/
  border: 1px solid #d6d6d6;
  margin: 0 14px;
}

.btnSelected {
  padding: 10px;
  min-height: 45px;
  width: 95%;
  border-radius: 9px;
  background-color: #42686e;
  border: none;
  color: white;
  margin: 0 14px;
}

.ques {
  padding-right: 10px;
}

.content_ques {
  text-align: left;
  font-size: 14px;
}

.spanBox {
  font-size: 14px;
}

.swiper {
  /*border: 2px solid red;*/
  position: relative;
  width: 90vw;

  /* 下面是为了让大家看的更清楚，加的修饰 */
  /*padding: 0 10%;*/
  margin: 0 auto;
}

.swiper .swiper-container {
  /*border: 2px solid pink;*/
  /*background-color: pink;*/
  /*transition: ;*/
  transition: transform 0.4s ease-in-out;
  /*position: relative;*/
  /*transition: left 0.4s ease-in-out;*/
  /* 为啥要设置-300px呢，因为我想让他默认在第二个滑块的位置，一会会给大家演示 */
  /*left: 0px;*/
  /* 让容器尽可能的宽，这样才能容纳更多的滑块 */
  width: 10000%;
  /* 让内部滑块可以排成一行 */
  display: flex;
  align-items: center;
  /* 下面是为了让大家看的更清楚，加的修饰 */
  /*background: red;*/
  padding: 0 0;
}

.swiper .swiper-container .swiper-item {
  /*border: 2px solid blue;*/
  /* padding: 10px; */
  display: flex;
  justify-content: center;
  align-items: center;
  /*margin: 10px;*/
  /*padding: 10px;*/
  transition: All 0.4s ease-in-out;
  /* 宽度设置1%会按照外层视图的宽度来铺满 */
  width: 1%;
  /*width: 1.142%;*/
  min-height: 400px;
  height: fit-content;
  padding-bottom: 10px;
  /*transform: scaleY(0.6);
        overflow: hidden;*/
  border-radius: 15px;
  /*background: #eee;*/

  /* 下面是为了让大家看的更清楚，加的修饰 */
  text-align: center;
  font-size: 40px;
  color: #fff;
}

.swiper .swiper-container .swiper-item:last-child {
  padding-top: 1.5rem;
}

.active {
  display: flex;
  /*height: 400px !important;*/
  transform: scaleY(1) !important;
  /*overflow: unset;*/
}

.show {
  opacity: 1;
}
</style>
